"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePublicService = void 0;
const base_service_1 = require("../base-service");
const constants_1 = require("../constants");
class BasePublicService extends base_service_1.BaseService {
    constructor(authorization, baseUrl, logger) {
        super(constants_1.PUBLIC_API_URL, authorization, baseUrl, logger);
    }
}
exports.BasePublicService = BasePublicService;
//# sourceMappingURL=base-public-service.js.map